import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { dummy_profile_pic, partnerCommissions, Sub, Sub2, Sub3, subCommissions, tier1, tier2 } from "../../assets/assets";
import { getStorageValue } from "../../service/shared.service";
import CurrencyFormatter from "../../utils/CurrencyFormatter";

const Tier = ({data,getback}:any) => {
  const tabs = ['Total Commission','Fixed Commission', 'Recurring Commission']
  const [selectedTab, setSelectedTab] = useState(0);
  const [tierData, setTierData] = useState([]);

  const profildata = useSelector((state: any) => state?.APIData?.partnerData);
  const partnerName = profildata.partner_profile && profildata.partner_profile[0].partner_name
  const partnerImage = profildata.partner_profile && profildata.partner_profile[0].partner_image
  const paymentData =getStorageValue("paymentData");

  const partnerSetting = profildata && profildata?.partner_profile &&  profildata?.partner_profile[0] && profildata?.partner_profile[0]?.partner_settings &&  profildata?.partner_profile[0]?.partner_settings[0]
  const fixedArray = data?.fixedHerarchy
  console.log(fixedArray,"fixedArray");
  useEffect(() => {
    const { hierarchy } = data;
    const firstPartnerExists = hierarchy && hierarchy[0]?.partners?.length > 0;
  
    if (firstPartnerExists) {
      setTierData(hierarchy);
    } else {
      getCommisions(partnerSetting?.share_type === 2 ? 1 : partnerSetting?.share_type === 3 ? 0 : 2  );
    }
  }, [data, partnerSetting]);
  
  const getCommisions = (index :any) => {
    setSelectedTab(index);
    const check = index === 1 ? data.fixedHerarchy : data?.hierarchy;
    setTierData(check);
  };
  
  return (
    <div className="main--tier">
         <div className="py-4 pb-0">
          {data && data.stats && (
 <button onClick={getback} className="mb-0 border-0 bg-transparent"><b> <span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
 <path d="M6.37998 3.95312L2.33331 7.99979L6.37998 12.0465" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
 <path d="M13.6667 8H2.44666" stroke="#292D32" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
 </svg>
 </span> Back</b></button>
          )}
     
    </div>
    {data && data.stats && (
      <>
        <div className="earn">
          {partnerSetting.share_type == 3  &&
        <div className="commission-tab">
          <ul>
            {tabs.map((item:any ,index:any) =>{
              return (
                <li key={index} onClick={() => getCommisions(index)} className={`tab ${selectedTab == index ? 'active' : ''} `}>
                  <div className="tab">{item}</div>
                </li>
              )
            })}
          </ul>
          
        </div>
        }     
      <div className="earn-header">
            <p className="earning--label">Amazing! You Will Earn</p>
        </div>
        <div className="row">
            <div className="col-lg-4 col-12">
            <div className="earning--amt" translate="no"><CurrencyFormatter amount={ selectedTab == 1  ? data?.statsFixed?.totalCommission : selectedTab == 0 ? (data?.stats?.totalCommission + data?.statsFixed?.totalCommission)  : data?.stats?.totalCommission}/></div>
          <div className="earning--commission">Total Commission</div>

            </div>
            <div className="col-lg-4 col-6">

                <div className="earn-commission border-end pe-2">
                    <div><img src={partnerCommissions} alt="" /></div>
                    <div><p className="mb-0"><b translate="no"><CurrencyFormatter amount={ selectedTab == 1 ? data?.statsFixed?.firstMonthCommission  :selectedTab == 0 ? data?.stats?.firstMonthCommission + data?.statsFixed?.firstMonthCommission   : data?.stats?.firstMonthCommission}/></b></p>
                    <p className="mb-0 f1-text"> First Month Commission from your Businesses</p></div>
                </div>

            </div>
            <div className="col-lg-4 col-6">
            <div className="earn-commission">
                    <div><img src={subCommissions} alt="" /></div>
                    <div><p className="mb-0"><b translate="no"><CurrencyFormatter amount={ selectedTab == 1 ? data?.statsFixed?.totalCommissionFromAgents : selectedTab == 0 ? data?.stats?.totalCommissionFromAgents + data?.statsFixed?.totalCommissionFromAgents   : data?.stats?.totalCommissionFromAgents}/></b></p>
                    <p className="mb-0 f1-text"> First Month Commission from sub-partners</p></div>
                </div>

            </div>
        </div>
        <div className="earning--info w-100 flex-unset">
          <ul>
            <li className="w-100 mb-1 ps-2">
              <i>*If you continue adding the following numbers each month</i>
            </li>
            <li className="earning--badge">
              <span translate="no">{ selectedTab == 1 ? data?.statsFixed?.totalBusinesses  : data?.stats?.totalBusinesses}</span> Businesses
            </li>
            <li className="earning--badge">
              <span translate="no">{ selectedTab == 1 ? data?.statsFixed?.totalPaymentPlans / data?.statsFixed?.totalBusinesses  :data?.stats?.totalPaymentPlans / data?.stats?.totalBusinesses}</span> Payment Plans/business
            </li>
            { partnerSetting.share_type !=2 && <li className="earning--badge">
              <span translate="no"><CurrencyFormatter amount={ selectedTab == 1 ? data?.statsFixed?.avgRecurringPerMonth  : data?.stats?.avgRecurringPerMonth}/></span> Avg. recurring
            </li>}
            <li className="earning--badge">
              <span translate="no">{data?.stats?.subPartnersCount}</span> Sub Partner
            </li>
          </ul>
        </div>
        <div className="earning--yearend pt-3">
        Your Year End Commission Will Be  
          <span className="ms-2" translate="no" style={{ fontSize: "28px", fontWeight: "bold" }}><CurrencyFormatter amount={  selectedTab == 1 ? data?.statsFixed?.totalYearEndCommission : selectedTab == 0 ? data?.stats?.totalYearEndCommission + data?.statsFixed?.totalYearEndCommission   :data?.stats?.totalYearEndCommission}/></span>
          <p style={{ marginTop: "-8px !important" }}>
            <i>
              *We assume your sub partners will add same number of businesses,
              payment plans and add sub partners under their account at each
              tier.
            </i>
          </p>
        </div>
      </div>
      </>
    
    )}
      

      {data && data.hierarchy && (
        <div className="tier">
        <div className="container-v2">
          <div className="tier--header">
            <h4>Tier Wise Monthly Commission</h4>
          </div>
          <div className="tier--thared">
            <ul className="tier--list">
                {tierData?.map((item:any,index:any)=>(
                <li key={index}>
                 <span>Tier {item.levelCommission ?item.level : item.level + 1}</span>
               </li>
                )
                )}
              
            </ul>
            <div className="tier--thared--topbar position-relative">
              <div className="d-flex justify-content-between align-items-center flex-grow-1">
                <div className="profile">
                  <div className="profile--img">
                    <img
                      src={ partnerImage ? partnerImage : 'https://common.denefits.com/doctor_profile/profile_placeholder.png'  }
                      alt="img"
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="25"
                      viewBox="0 0 26 25"
                      fill="none"
                    >
                      <path
                        d="M12.8469 21.5397L12.5408 20.5877L12.8469 21.5397C12.9465 21.5076 13.0535 21.5076 13.1531 21.5397L13.4592 20.5877L13.1531 21.5397L17.7943 23.0322C19.4051 23.5502 21.0545 22.3518 21.0596 20.6598L21.0744 15.7845C21.0747 15.6799 21.1078 15.5781 21.169 15.4933L24.0227 11.5405C25.0131 10.1685 24.3831 8.22958 22.7754 7.70183L18.1433 6.18124C18.044 6.14863 17.9574 6.0857 17.8957 6.0013L15.0181 2.06579C14.0194 0.699896 11.9806 0.699901 10.9819 2.06579L8.10435 6.0013C8.04264 6.0857 7.95602 6.14863 7.85668 6.18124L3.22457 7.70183C1.61691 8.22958 0.986906 10.1685 1.97733 11.5405L4.831 15.4933C4.8922 15.5781 4.92529 15.6799 4.9256 15.7845L4.94037 20.6598C4.94549 22.3518 6.59487 23.5502 8.2057 23.0322L12.8469 21.5397Z"
                        fill="url(#paint0_linear_5674_15059)"
                        stroke="#F8FBFF"
                        strokeWidth="2"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_5674_15059"
                          x1="13"
                          y1="1"
                          x2="13"
                          y2="25"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#FBBC04" />
                          <stop offset="1" stopColor="#FFCA99" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div className="profile--info">
                    <div translate="no" className="name">{partnerName && partnerName}</div>
                    <div className="badge">You</div>
                  </div>
                </div>
                <div className="commissions py-2 py-lg-0 ">
                  <span className="text--green commissions--amt" translate="no">
                  <CurrencyFormatter amount={(() => {
                      // if (paymentData?.total_revenue !== null && paymentData?.total_revenue !== undefined) {
                      //   return paymentData.total_revenue;
                      // }
                      console.log(partnerSetting);
                      
                  
                        if ( fixedArray && partnerSetting && partnerSetting.share_type === 3 && selectedTab === 0) {
                          return fixedArray &&  fixedArray[0]?.totalShareFromContracts + ( tierData &&  tierData?.[0] && tierData?.[0]['levelCommission']);
                        }
                        else  if ( tierData && tierData?.[0]&& tierData?.[0]['partnersAtLevel']) {
                          return tierData[0]['levelCommission'];
                        }
                        else{
                          return (paymentData && paymentData['total_revenue'] || 0);
                        }                      
                      })()}  />
                 
                  </span>
                 { selectedTab == 2 && <span className="commissions--rate">( <i translate="no">{ tierData &&  tierData[0] &&tierData[0]['percentage']}</i> {tierData[0]&&  tierData[0]['levelCommission'] ? "%" : ''} commission rate )
                  </span>}
                 { selectedTab <2 &&   <span className="commissions--rate">commission Earned</span>}
                </div>
              </div>
            </div>
            <div className="tier--thared--nested">
                {tierData.map((item:any, index:any)=>{
                     if (index === 0) {
                        return null;
                      }
                      return(
                        <div className="tier--thared--nested--inner" key={index}>
                        <div className="dots"></div>
                        <div className="line"></div>
                        <div className="d-lg-flex justify-content-between align-items-center flex-grow-1 p-3 py-2 p-lg-0">
                          <p className=" fw-bold mb-1 d-lg-none">Tier {item.levelCommission ?item.level : item.level + 1}</p>
                        <div className="profile">
                          {/* {JSON.stringify(item.partners)} */}
                          {index == 1 &&(
                            
                            <div className="list--img">
                              {/* {item?.partners?.length}{ JSON.stringify(item?.partners)} */}
                              {(item.partnersAtLevel ? item.partnersAtLevel >= 1 : item.partners.length >= 1) &&<span ><img className="dummy-tier" src={ item?.partners?.length   ? item.partners[0].partner_image ? item.partners[0].partner_image : dummy_profile_pic : tier2} /></span> }
                              {(item.partnersAtLevel ? item.partnersAtLevel >= 2 : item.partners.length >= 2) &&<span > <img className="dummy-tier" src={ item?.partners?.length   ? item.partners[0].partner_image ? item.partners[0].partner_image : dummy_profile_pic : Sub2} /></span> }
                              {(item.partnersAtLevel ? item.partnersAtLevel >= 3 : item.partners.length >= 3  ) &&<span ><img className="dummy-tier" src={ item?.partners?.length   ? item.partners[0].partner_image ? item.partners[0].partner_image : dummy_profile_pic: Sub3} /></span> }
                              {(item.partnersAtLevel ? item.partnersAtLevel > 3  : item.partners.length) &&  (item.partnersAtLevel > 3  || item.partners.length > 3)  && <span className="count">+{(item.partnersAtLevel ? item.partnersAtLevel : item.partners.length ) - 3} </span> }
                          
                            </div>
                          )}
                          {index !=1 && (
                            <div className="profile--img">
                            <img src={Sub} alt="" />
                            </div>
                          )}
                            <div className="profile--info">
                            <div className="name">{item.partnersAtLevel ? item.partnersAtLevel : item?.partners?.length} Sub Partners</div>
                            </div>
                        </div>
                        <div className="commissions">
                            <span className="text--green commissions--amt">
                            <span className="d-flex" translate="no">
                              <CurrencyFormatter
                               amount=  {  item?.total_amount != undefined || item.total_amount != null ? item.total_amount
                        : partnerSetting && partnerSetting.share_type== 3 &&  selectedTab == 0 ? ( item.levelCommission  + (fixedArray && fixedArray[index]?.totalShareFromContracts ) )  
                        : selectedTab == 1 ? item.totalShareFromContracts :
                        selectedTab == 2 ?  item?.levelCommission : item.levelCommission }/> <span className="ms-1"> Commission Earned </span></span> 
                            </span>
                           { selectedTab == 2 && <span className="commissions--rate rate2">{item.percentage} {item.levelCommission ? "%" : ''}  commission rate</span>}
                        </div>
                        </div>
                        </div>
                      )}
                  )} 
            </div>
          </div>
        </div>
      </div>
      )}

      
    </div>
  );
};

export default Tier;
